import { SignIn } from '@clerk/clerk-react';

const IS_SATELLITE = import.meta.env.VITE_CLERK_IS_SATELLITE === 'true';
const CLERK_DOMAIN = import.meta.env.VITE_CLERK_DOMAIN;

export default function SignInPage() {
  if (IS_SATELLITE) {
    // Mirror signUpPage's ticket-forwarding for parity. Existing-user
    // invitations currently use direct-add (no ticket flow), so this
    // branch isn't exercised by today's invite path — but keeping the
    // redirect ticket-aware avoids re-introducing the same bug if a
    // future change ever routes a sign-in ticket through here.
    const params = new URLSearchParams(window.location.search);
    const ticket = params.get('__clerk_ticket');
    const status = params.get('__clerk_status');
    let url = `https://accounts.${CLERK_DOMAIN}/sign-in?redirect_url=${encodeURIComponent(window.location.origin)}`;
    if (ticket) url += `&__clerk_ticket=${encodeURIComponent(ticket)}`;
    if (status) url += `&__clerk_status=${encodeURIComponent(status)}`;
    window.location.href = url;
    return null;
  }

  return (
    <div className="login-page d-flex align-items-center justify-content-center">
      <SignIn
        routing="path"
        path="/sign-in"
        signUpUrl="/sign-up"
        forceRedirectUrl="/dashboard"
      />
    </div>
  );
}
